<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0">
      <h3 class="card-title text-dark">برنامه‌‌ها</h3>
      <div class="card-toolbar">
        <router-link
          :to="{ name: 'programs-index' }"
          class="btn btn-sm btn-primary"
        >
          بیشتر
        </router-link>
      </div>
    </div>
    <div class="card-body pt-2 pb-4">
      <div v-if="programs.length">
        <template v-for="(program, i) in programs">
          <div
            v-if="i < 5"
            class="d-flex align-items-center mb-3 overflow-hidden"
            :key="`program-${program.id}`"
          >
            <router-link
              :to="{ name: 'programs-show', params: { id: program.id } }"
              class="border-bottom pb-2"
            >
              <div
                class="ml-2 font-size-lg pt-0 text-left text-nowrap text-overflow-ellipsis w-200px"
              >
                {{ program.name }}
              </div>
            </router-link>
          </div>
        </template>
      </div>
      <div v-else>برنامه‌ای یافت نشد.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "programs-list",
  props: {
    programs: Array
  },
  data() {
    return {};
  },
  computed: {}
};
</script>
